import { atom, useAtom } from 'jotai';

const defaultCompanySortingAtom = atom<boolean>(false);
export const useCompanySorting = () => {
  defaultCompanySortingAtom.debugLabel = 'companySorting';
  const [companySorting, setCompanySorting] = useAtom(defaultCompanySortingAtom);

  return {
    companySorting,
    setCompanySorting,
  };
};

const defaultCompanyHeadingAtom = atom<string>('');
export const useCompanyHeading = () => {
  defaultCompanyHeadingAtom.debugLabel = 'companyHeadingAtom';
  const [companyHeading, setCompanyHeading] = useAtom(defaultCompanyHeadingAtom);

  return {
    companyHeading,
    setCompanyHeading,
  };
};
